// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex'

import BootstrapVue from 'bootstrap-vue'
//import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

window.webpackData = __webpack_require__

// import VueObserveVisibility from 'vue-observe-visibility'
//import 'webpack-runtime-require'

import './scss/main.scss'
// require('./scss/main.scss')
import './css/portal-series.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlay, faCaretUp, faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import directives from './directives'

import $ from 'jquery'
import platform from 'platform'

import VTooltip from 'v-tooltip'

// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: 'UA-142593025-1',
//   router
// })

// VTooltip.options.defaultTrigger = 'hover focus click'
let tip_options = {
  defaultPlacement: 'left',
  defaultTrigger: 'hover focus click'
}
Vue.use(VTooltip, tip_options)
// import turboJson from 'turbo-json-parse'

// import _components from './components/loader'
// library.add(faPlay)
// library.add(faCaretUp)
library.add([ faPlay, faCaretUp, faBars ])

Vue.use(BootstrapVue)

Vue.use(VueVideoPlayer, /* {
  options: global default options,
  events: global videojs events
} */)

// Vue.use(VueObserveVisibility)
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)

import VueSweetalert2 from 'vue-sweetalert2'
Vue.use(VueSweetalert2)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-TW'

Vue.use(ElementUI, { locale })

Vue.directive('init', {
  bind: function (el, binding /*, vnode*/ ) {
    //console.log(binding.value); //# This line is optional, of course.
  }
})

Vue.component('font-awesome-icon', FontAwesomeIcon)

const jqueryExtend = require('./jquery-extend')
jqueryExtend($)

const fixIdScrollingMixin = {
  mounted() {
    let _this = this

    setTimeout(function() {
      $('a').each((index, item) => {
        let $a = $(item)
        let href = $a.attr('href')


        let gotoElementById = function($target) {
          $('html, body').animate({
            scrollTop: $target.offset().top
          }, 500)
        }

        if (href.indexOf('#/#') == 0) {
          let id = href.substr(3)

          let $target = $(`#${id}-x`)
          if ($target && $target['length'] && $target['length'] > 0) {
            $target.one('click', function($event) {
              console.log(`click goto #${id}`)
              $event.preventDefault()
              $event.stopPropagation()

              gotoElementById($target)

              return false
            })
          }
        }
      })
    }, 500)
  },

  watch: {
      $route(to, from) {
        // return
          const currentRoute = this.$router.currentRoute
          const idToScrollTo = currentRoute.hash

          // return false

          // console.log('main.js',
          //   ' ## fixIdScrollingMixin ',
          //   `currentRoute : `,
          //   currentRoute,
          //   'idToScrollTo : ',
          //   idToScrollTo)
          // return

          this.$nextTick(() => {
              if (idToScrollTo && document.querySelector(idToScrollTo)) {
                  document.querySelector(idToScrollTo).scrollIntoView()
              }
          })
      },
  },
}

const disableContextClickMixin = {
  mounted() {
    document.addEventListener("contextmenu", function(e) {
      // console.log('main.js',
      //   'disableContextClickMixin',
      //   e)
      e.preventDefault()
      e.stopPropagation()

      return false
    })
  }
}

// const getAttributeMixin = {
//   methods: {
//     getAttribute(_obj, attributeName, defaultValue) {
//       return ''
//     }
//   }
// }

// Vue.directive('show-mobile-mode', {
//   bind: function(el, binding) {
//     let expr = binding.value

//     console.log('main.js',
//       '[directive] show-mobile-mode ',
//       ' @watch for "expr" : ',
//       expr)
//   }
// })

directives.showMobileModeDirective(Vue)
// directives.editableDirective(Vue)

Vue.directive('follow', {
  bind: function(el, binding) {

    let $el = $(el)

    let expr = binding.value

    // console.log('main.js',
    //   '[directive] follow.binding : ',
    //   expr)

    let platform_name = platform['name'].toLowerCase()

    // console.log('main.js',
    //   '[directive] follow :',
    //   'platform',
    //   platform_name)

    if (expr[platform_name]) {
      if (expr[platform_name]['target_y']) expr.target_y = expr[platform_name]['target_y']
      if (expr[platform_name]['target_x']) expr.target_x = expr[platform_name]['target_x']
    }

    // el.style.top = `${expr.target_y}px`
    // el.style.left = `${expr.target_x}px`

    let _watchTargetWidth = function($target) {
      // console.log('main.js',
      //   '[directive] follow :',
      //   '_watchTargetWidth',
      //   $target.width())

      if ($target['last_width'] != $target.width()) {
        // delete expr.scale_width
        // delete expr.scale_width_for

        // console.log('main.js',
        //   '[directive] follow :',
        //   '_watchTargetWidth >> expr :',
        //   expr)

        run_size_adjust()
        return
      }
      else {
        setTimeout(() => { _watchTargetWidth($target) }, 200)
      }
    }

    let run_size_adjust = function() {
      let $target = $(expr.target)
      if (!$target || $target == undefined || $target == null) return

      // console.log('main.js',
      //   '[directive] follow :',
      //   'test target.width',
      //   $target.width())
      $target['last_width'] = $target.width()

      setTimeout(() => { _watchTargetWidth($target) }, 200)

      let dim_target = $target.getHiddenDimensions()

      let target_scale = dim_target.width / expr.ref_width

      // scale size
      let scale_width = expr['el_width'] / expr.ref_width

      // console.log('main.js',
      //   '[directive] follow >>',
      //   ', test target.width : ',
      //   $target.width(),
      //   ', dim_target : ',
      //   dim_target,
      //   ', target_scale : ',
      //   target_scale,
      //   ', scale_width : ',
      //   scale_width)

      // size calculation for rwd
      let _el_width_offset = (expr['el_width'] * scale_width)
      let _el_height_offset = (expr['el_height'] * scale_width)

      // console.log('main.js',
      //   '[directive] follow >> ',
      //   ', scale_width : ',
      //   scale_width,
      //   ', target_scale : ',
      //   target_scale,
      //   ', _el_width_offset : ',
      //   _el_width_offset,
      //   ', _el_height_offset : ',
      //   _el_height_offset,
      //   ', _el_top_offset : ',
      //   _el_top_offset,
      //   ', _el_left_offset : ',
      //   _el_left_offset)

      // console.log('main.js',
      //   '[directive] follow >> ',
      //   ', _el_left_offset : ',
      //   _el_left_offset)

      _el_width_offset = 0
      _el_height_offset = 0

      let _el_width =
        (expr['el_width'] * target_scale) + _el_width_offset
      let _el_height =
        (expr['el_height'] * target_scale) + _el_height_offset

      _el_width = _el_width > expr['el_width'] ? expr['el_width'] : _el_width

      _el_height = _el_height > expr['el_height'] ? expr['el_height'] : _el_height

      // console.log('main.js',
      //   '[directive] follow :',
      //   '$target.width()',
      //   $target.width(),
      //   'target_scale',
      //   target_scale,
      //   'expr[el_width]',
      //   expr['el_width'],
      //   '_el_width',
      //   _el_width)

      // size
      // if (_el_width != expr['el_width']) $el.width(_el_width)
      $el.width(_el_width)

      // if (_el_width != expr['el_width']) {
      //   $el.height(
      //     (expr['el_height'] * target_scale) + _el_height_offset)
      // }
      $el.height(_el_height)

      // position
      let _el_top_offset = (dim_target.offsetTop * scale_width)
      let _el_left_offset = (dim_target.offsetLeft * scale_width)

      _el_top_offset = expr['el_height'] - _el_height
      _el_left_offset = expr['el_width'] - _el_width

      if (_el_left_offset > 0) _el_left_offset *= scale_width

      // console.log('main.js',
      //   '[directive] follow >> ',
      //   ', _el_left_offset : ',
      //   _el_left_offset)

      // $el.css('left', (expr['target_x'] * target_scale))
      $el.css('top', (expr['target_y'] * target_scale))
      $el.css('left', (expr['target_x'] * target_scale) + _el_left_offset)
      // $el.css('top', (dim_target.height - (expr['target_y'] * target_scale)) * -1)

      // console.log('main.js',
      //   '[directive] watch $target',
      //   'dim_target :',
      //   dim_target,
      //   ', target_scale :',
      //   target_scale)

      $el.find('.sprite-principal-absolute').removeClass('sprite-principal-absolute')
    }

    // el.addEventListener('mouseover', run_size_adjust)
    el.addEventListener('mouseover', function() {
      el.classList.remove('hover')
      el.classList.add('hover')
    })
    el.addEventListener('mouseleave', function($event) {
      el.classList.remove('hover')
    })

    setTimeout(run_size_adjust, 500)
  }
})

Vue.config.productionTip = false

// if (CKEditorAPI) {
//   CKEditorAPI.editor($, Vue)
// }

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  mixins: [ fixIdScrollingMixin, disableContextClickMixin, /*getAttributeMixin*/ ],
  // mixins: [ disableContextClickMixin, /*getAttributeMixin*/ ],
  template: '<App/>',
})

// _components.IndexComponents.forEach((component) => {
//   Vue.component(component)
// })
// _components.MenuComponents.forEach((component) => {
//   Vue.component(component)
// })



// WEBPACK FOOTER //
// ./src/main.js